import * as o from "react";
import t from "../lib/IconBase.es.js";
import a from "../defs/CodeBlock.es.js";
const e = o.forwardRef((c, r) => /* @__PURE__ */ o.createElement(t, { ref: r, ...c, weights: a }));
e.displayName = "CodeBlockIcon";
const n = e;
export {
  n as CodeBlock,
  e as CodeBlockIcon
};
